export enum HttpKey {
    REMOVE_IMAGE_BACKGROUND,
    CONVERT_TO_JPG,
}
export enum UserAbilityType {
    USE_CREDIT = "use_credit",
    USE_ORTERY_DIRECT_3 = "ortery_direct_3",
    CONVERT_TO_JPG = "convert_to_jpg",
    VIEW_ANALYSIS = "view_analysis",
}
export enum HistoryType {
    Undo,
    Redo,
}
export enum SettingButton {
    Save,
    SaveAs,
    ExitFullscreen,
    RevertAllChange,
    Fullscreen,
    OpenInNewBrowser,
    Redo,
    Undo,
    RollbackSetting,
    DowloadImage,
}
export enum AccessPageType {
    Share,
    Direct,
}
export enum VIEWER_TYPE {
    IMAGE = 1,
    VIDEO,
    HTML,
}
